export enum SocketEvents {
  CONNECT = "connect",
  DISCONNECT = "disconnect",
  CONNECT_ERROR = "connect_error",
  ADMIN_ROUTE_LOCATION_STATUS_UPDATE = "admin:route:location:status:update",
  DRIVER_CONNECT = "admin:driver:connect",
  DRIVER_DISCONNECT = "admin:driver:disconnect",
  ADMIN_DRIVER_STATUS_LOCATION_UPDATE = "admin:driver:status:location:update",
  ADMIN_DRIVER_TOOK_ROUTE = "admin:driver:took:route",
  ADMIN_DRIVER_PLOW_BREAKDOWN = "admin:driver:plow-breakdown",
  ADMIN_ROUTE_CHANGES_CHANGED = "admin:route-changes:changed",
  ADMIN_ROUTE_DRIVER_NOTE_CHANGED = "admin:emit:live-route:location-note:changed",
  ADMIN_RECALCULATE_EST = "admin:emit:region:est:calculation-changed",
  ADMIN_SYNC_ROUTE_WITH_REGION = "admin:emit:region-route-sync-completed",
  ADMIN_ROUTE_EST_TIME_CALCULATED = "admin:emit:route-est-time-calculated",
  ADMIN_ROUTE_UPDATED = "admin:emit:route-updated",
  ADMIN_ROUTE_LOCATION_ORDER_UPDATED = "admin:emit:route-location-order-updated",
  LOCATION_SYNC_FROM_CSV = "admin:emit:location-sync-from-csv",
  LOCATION_SYNC_FROM_CSV_COMPLETED = "admin:emit:location-sync-from-csv-completed",
  LOCATION_SYNC_FROM_CSV_PROGRESS = "admin:emit:location-sync-from-csv-progress",
  SERVICE_ALERT_CREATED = "admin:emit:service-alert-created",
  WEATHER_REPORT_CREATED = "admin:emit:weather-report-created",
}

export enum SocketEmitters {
  EMIT = "emit",
  ADMIN_NOTIFICATION = "adminNotification",
}

export type RecalcEstResponse = {
  calculationId: string;
  status: "started" | "success";
};

export type AdminLocationNoteChanged = {
  routeId: string;
  locationId: string;
  locationNoteCount: number;
  locationNoteId: string;
};

export type LocationSyncFromCsvResponse = {
  newAddressAndCustomer: number;
  existingAddressNewCustomer: number;
  updateCustomerOnExistingAddress: number;
  updateAddressOfExistingCustomer: number;
  existingCustomerNewAddress: number;
  validationError: number;
  validationErrors: ValidationError[];
};

export type ValidationError = {
  row: number;
  errors: string[];
};

export type LocationSyncFromCsvProgressResponse = {
  processed?: number;
  percentage: number;
  status: "processing" | "completed" | "error";
  message?: string;
};
